{
  "INAPP-2055.spotlight.body": [
    {
      "type": 0,
      "value": "Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"
    }
  ],
  "INAPP-2055.spotlight.primary": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "INAPP-2055.spotlight.secondary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-2055.spotlight.title": [
    {
      "type": 0,
      "value": "Create rich and informative alerts"
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.body": [
    {
      "type": 0,
      "value": "Expand to quickly view all alerts in the group."
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.title": [
    {
      "type": 0,
      "value": "View grouped alerts"
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.body": [
    {
      "type": 0,
      "value": "Rovo helps you classify your alerts as signal or noise so you can focus on what matters most."
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.title": [
    {
      "type": 0,
      "value": "Triage alerts faster"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.go-back": [
    {
      "type": 0,
      "value": "Go back"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ]
}